import { DuctSuppliesModeType } from 'utils/duct-supplies';
import { RadialDuctModeKeyType } from 'utils/ducting-products';

export type ZoneDuctModesMapType = Record<string, RadialDuctModeKeyType>;

function isModeKey(value: unknown): value is RadialDuctModeKeyType {
  return value === 'flexOnly' || value === 'metalFlex' || value === 'metalOnly';
}

export function parseZoneDuctModes(raw: string | null): ZoneDuctModesMapType {
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    const modes: ZoneDuctModesMapType = {};
    Object.entries(parsed).forEach(([zoneUniqueId, modeKey]) => {
      if (isModeKey(modeKey)) {
        modes[zoneUniqueId] = modeKey;
      }
    });
    return modes;
  } catch {
    return {};
  }
}

export function serializeZoneDuctModes(
  modes: ZoneDuctModesMapType
): string | null {
  if (Object.keys(modes).length === 0) return null;
  return JSON.stringify(modes);
}

export function ductSuppliesModeForKey(
  key: RadialDuctModeKeyType
): DuctSuppliesModeType {
  if (key === 'metalFlex') return 'metal_flex';
  if (key === 'metalOnly') return 'metal_only';
  return 'flex_only';
}

export const ZONE_DUCT_MODE_LABELS: Record<RadialDuctModeKeyType, string> = {
  flexOnly: 'All Flex',
  metalFlex: 'Metal + Flex Tails',
  metalOnly: 'All Round Metal'
};
